import SafeHtmlContent from "./SafeHtmlContent";

const urlPattern = /(https?:\/\/[^\s]+)/g;
const emphasisPattern = /(\*\*[^*]+\*\*|_[^_]+_)/g;

function emphasis(text, keyPrefix) {
  return text.split(emphasisPattern).map((part) => {
    const key = `${keyPrefix}-${part}`;
    if (part.startsWith("**") && part.endsWith("**")) return <strong key={`bold-${key}`}>{part.slice(2, -2)}</strong>;
    if (part.startsWith("_") && part.endsWith("_")) return <em key={`italic-${key}`}>{part.slice(1, -1)}</em>;
    return part;
  });
}

export default function RichTextContent({ content }) {
  if (content.includes("<")) return <SafeHtmlContent html={content} />;
  return <>{content.split("\n").map((paragraph) => <p key={`paragraph-${paragraph}`}>{paragraph.split(urlPattern).map((part) => part.match(/^https?:\/\//) ? <a key={`url-${part}`} href={part} target="_blank" rel="noreferrer">{part}</a> : emphasis(part, paragraph))}</p>)}</>;
}